<template>
  <div>
    <template v-for="block in content.blocks" :key="block.id">
      <text-block v-if="block.type === contentTypes.Text" :_block="block" />
      <mention-block
        v-else-if="block.type === contentTypes.Mention"
        :_block="block"
      />
      <softbreak-block
        v-else-if="block.type === contentTypes.Softbreak"
        :_block="block"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { ChatMessageContent } from "../../../../types/ChatMessageContent";
import TextBlock from "@/components/chat/messageparts/blocks/TextBlock.vue";
import { ChatMessageContentBlockType } from "../../../../types/ChatMessageContentBlock";
import MentionBlock from "@/components/chat/messageparts/blocks/MentionBlock.vue";
import SoftbreakBlock from "@/components/chat/messageparts/blocks/SoftbreakBlock.vue";

export default defineComponent({
  name: "ContentsMessagePart",
  components: { SoftbreakBlock, MentionBlock, TextBlock },
  props: {
    _content: {
      required: true,
      type: Object as PropType<ChatMessageContent>,
      validator(_content: ChatMessageContent) {
        return !!_content.type && !!_content.blocks;
      }
    }
  },
  computed: {
    content(): ChatMessageContent {
      return this._content;
    },
    contentTypes() {
      return ChatMessageContentBlockType;
    }
  }
});
</script>

<style scoped></style>
